/* The Customs Club — interactions & motion */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches || /[?&]noanim/.test(location.search);
  const root = document.documentElement;

  if (/[?&]noanim/.test(location.search)) root.classList.add("no-intro", "no-anim");

  /* ---------- intro veil: only on first page of the session ---------- */
  try {
    if (sessionStorage.getItem("tcc-visited")) root.classList.add("no-intro");
    sessionStorage.setItem("tcc-visited", "1");
  } catch (e) { /* storage unavailable */ }

  window.addEventListener("load", () => {
    document.body.classList.add("is-loaded");
    // The intro veil can cancel the browser's jump to #anchor, so scroll there once loaded.
    const target = location.hash.length > 1 && document.getElementById(location.hash.slice(1));
    if (target) setTimeout(() => target.scrollIntoView({ behavior: "instant", block: "start" }), 300);
  });
  window.addEventListener("pageshow", (e) => { if (e.persisted) document.body.classList.remove("is-leaving"); });

  /* ---------- page transitions ---------- */
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === "_blank") return;
    const href = a.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:") || /^https?:/.test(href)) return;
    if (a.hash && a.pathname === location.pathname) return; // same-page anchor: just scroll
    if (reduced) return;
    e.preventDefault();
    document.body.classList.add("is-leaving");
    setTimeout(() => { window.location.href = href; }, 520);
  });

  /* ---------- home hero: name + image first, everything else ~1s later ---------- */
  const heroDark = $(".hero-dark");
  if (heroDark) {
    const b = document.body;
    if (reduced) {
      b.classList.add("stage-1", "stage-2", "stage-3");
    } else {
      const img = $("img", heroDark);
      let started = false;
      const start = () => {
        if (started) return;
        started = true;
        requestAnimationFrame(() => b.classList.add("stage-1"));
        setTimeout(() => b.classList.add("stage-2"), 1500);
        setTimeout(() => b.classList.add("stage-3"), 2300);
      };
      if (img.complete) start(); else { img.addEventListener("load", start); img.addEventListener("error", start); setTimeout(start, 1500); }
    }
  }

  /* ---------- header ---------- */
  const header = $(".site-header");
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 24);
    if (heroDark) header.classList.toggle("is-dark", window.scrollY < heroDark.offsetHeight - 80);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  $$(".nav__item").forEach((item) => {
    const link = $(".nav__link", item);
    if (!$(".dropdown", item)) return;
    link.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") { e.preventDefault(); item.classList.add("is-open"); $(".dropdown a", item)?.focus(); }
    });
    item.addEventListener("keydown", (e) => { if (e.key === "Escape") { item.classList.remove("is-open"); link.focus(); } });
    item.addEventListener("focusout", (e) => { if (!item.contains(e.relatedTarget)) item.classList.remove("is-open"); });
  });

  $(".menu-toggle")?.addEventListener("click", () => {
    const open = document.body.classList.toggle("menu-open");
    $(".menu-toggle").setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  });

  /* ---------- split headlines into animated words ---------- */
  $$("[data-split]").forEach((el) => {
    const walk = (node, out) => {
      node.childNodes.forEach((n) => {
        if (n.nodeType === 3) n.textContent.split(/(\s+)/).forEach((t) => t && out.push({ t, cls: null }));
        else if (n.nodeName === "BR") out.push({ br: true });
        else out.push({ t: n.textContent, cls: n.className, tag: n.nodeName.toLowerCase() });
      });
      return out;
    };
    const parts = walk(el, []);
    let i = 0;
    el.innerHTML = parts.map((p) => {
      if (p.br) return "<br>";
      if (/^\s+$/.test(p.t)) return " ";
      const inner = p.tag ? `<${p.tag} class="${p.cls || ""}">${p.t}</${p.tag}>` : p.t;
      return `<span class="split-line" style="display:inline-block"><span class="split-word" style="--w:${i++}">${inner}</span></span>`;
    }).join("");
  });

  /* ---------- scroll reveals ---------- */
  $$("[data-stagger]").forEach((group) => {
    const step = parseFloat(group.dataset.stagger) || 0.08;
    [...group.children].forEach((c, i) => {
      if (!c.hasAttribute("data-reveal")) c.setAttribute("data-reveal", "");
      c.style.setProperty("--d", `${(i % 8) * step}s`);
    });
  });
  const revealTargets = $$("[data-reveal], [data-mask], [data-split], .section-rule, .step, [data-count], .progress, .masonry .mcard");
  if (reduced || !("IntersectionObserver" in window)) {
    revealTargets.forEach((el) => { el.classList.add("is-in"); if (el.dataset.count) el.textContent = el.dataset.count + (el.dataset.suffix || ""); const i = el.classList.contains("progress") && el.querySelector("i"); if (i) i.style.width = i.dataset.w; });
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add("is-in");
        if (en.target.hasAttribute("data-reveal")) {
          const d = parseFloat(getComputedStyle(en.target).getPropertyValue("--d")) || 0;
          setTimeout(() => { en.target.removeAttribute("data-reveal"); en.target.style.removeProperty("--d"); }, 1200 + d * 1000);
        }
        if (en.target.hasAttribute("data-count")) countUp(en.target);
        if (en.target.classList.contains("progress")) { const i = $("i", en.target); if (i) i.style.width = i.dataset.w; }
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -6% 0px" });
    // Clip-path masks hide the whole box, which the observer reports as never visible,
    // so masked elements are revealed from their bounding box on scroll instead.
    const isClipped = (el) => el.matches("[data-mask], .masonry .mcard");
    let clipped = revealTargets.filter(isClipped);
    revealTargets.filter((el) => !isClipped(el)).forEach((el) => io.observe(el));
    const checkClipped = () => {
      const vh = window.innerHeight;
      clipped = clipped.filter((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.94 && r.bottom > 0) { el.classList.add("is-in"); return false; }
        return true;
      });
      if (!clipped.length) window.removeEventListener("scroll", onClipScroll);
    };
    let clipTick = false;
    const onClipScroll = () => { if (!clipTick) { clipTick = true; requestAnimationFrame(() => { clipTick = false; checkClipped(); }); } };
    if (clipped.length) {
      window.addEventListener("scroll", onClipScroll, { passive: true });
      window.addEventListener("resize", onClipScroll);
      requestAnimationFrame(checkClipped);
    }
  }

  function countUp(el) {
    const target = parseFloat(el.dataset.count);
    const suffix = el.dataset.suffix || "";
    const dur = 1600;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* ---------- parallax ---------- */
  const parallax = $$("[data-parallax]");
  if (parallax.length && !reduced) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      parallax.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.parallax) || 0.12;
        const offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener("scroll", () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- toast + bag ---------- */
  const toast = $(".toast");
  let toastTimer;
  const showToast = (msg) => {
    if (!toast) return;
    $("span", toast).textContent = msg;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2200);
  };
  const bag = $(".bag-count");
  let bagCount = 0;
  const shopifyCart = bag && bag.dataset.count !== undefined;
  if (shopifyCart) bagCount = parseInt(bag.dataset.count, 10) || 0;
  else { try { bagCount = parseInt(localStorage.getItem("tcc-bag") || "0", 10) || 0; } catch (e) {} }
  const renderBag = (bump) => {
    if (!bag) return;
    bag.textContent = bagCount;
    bag.classList.toggle("is-visible", bagCount > 0);
    if (bump) { bag.classList.remove("is-bump"); void bag.offsetWidth; bag.classList.add("is-bump"); }
  };
  renderBag(false);
  $$("[data-add-cart]").forEach((b) => b.addEventListener("click", (e) => {
    e.preventDefault();
    bagCount++;
    try { localStorage.setItem("tcc-bag", String(bagCount)); } catch (err) {}
    renderBag(true);
    showToast(b.dataset.addCart || "Added to your bag");
  }));
  $$("[data-toast]").forEach((b) => b.addEventListener("click", (e) => {
    if (b.tagName === "BUTTON" || b.getAttribute("href") === "#") e.preventDefault();
    showToast(b.dataset.toast);
    if (b.dataset.doneLabel) { b.textContent = b.dataset.doneLabel; b.classList.add("is-done"); }
  }));

  /* ---------- Shopify: add to cart without leaving the page ---------- */
  $$('form[action$="/cart/add"]').forEach((form) => form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (btn) btn.disabled = true;
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || "Could not add to bag");
      const cart = await fetch("/cart.js").then((r) => r.json());
      bagCount = cart.item_count;
      renderBag(true);
      showToast(form.dataset.toast || "Added to your bag");
    } catch (err) {
      showToast(err.message);
    } finally { if (btn) btn.disabled = false; }
  }));

  /* ---------- swatches & single-select groups ---------- */
  document.addEventListener("click", (e) => {
    const sw = e.target.closest(".swatch");
    if (sw) {
      e.preventDefault();
      $$(".swatch", sw.parentElement).forEach((s) => s.classList.toggle("is-active", s === sw));
      return;
    }
    const opt = e.target.closest("[data-group] > *");
    if (opt && !opt.matches("[data-group]")) {
      const group = opt.parentElement;
      $$(":scope > *", group).forEach((o) => o.classList.toggle("is-active", o === opt));
      if (group.dataset.group === "gallery") swapGallery(opt);
    }
  });

  /* ---------- filter tabs ---------- */
  $$("[data-filter-tabs]").forEach((tabs) => {
    const grid = $(tabs.dataset.filterTabs);
    $$("[data-filter]", tabs).forEach((tab) => tab.addEventListener("click", () => {
      $$("[data-filter]", tabs).forEach((t) => t.classList.toggle("is-active", t === tab));
      if (!grid) return;
      const f = tab.dataset.filter;
      const cards = [...grid.children];
      cards.forEach((c) => c.classList.add("is-filtering"));
      setTimeout(() => {
        cards.forEach((c) => {
          const show = f === "all" || (c.dataset.cat || "").split(" ").includes(f);
          c.classList.toggle("is-hidden", !show);
        });
        const shown = cards.filter((c) => !c.classList.contains("is-hidden")).length;
        const counter = tabs.dataset.filterCount && $(tabs.dataset.filterCount);
        const noun = tabs.dataset.filterNoun || "item";
        if (counter) counter.textContent = `Showing ${shown} ${noun}${shown === 1 ? "" : "s"}`;
        const empty = tabs.dataset.filterEmpty && $(tabs.dataset.filterEmpty);
        if (empty) empty.hidden = shown > 0;
        requestAnimationFrame(() => cards.forEach((c, i) => {
          c.style.transitionDelay = `${(i % 4) * 0.05}s`;
          c.classList.remove("is-filtering");
          setTimeout(() => { c.style.transitionDelay = ""; }, 700);
        }));
      }, 300);
    }));
  });

  /* ---------- wishlist hearts ---------- */
  document.addEventListener("click", (e) => {
    const h = e.target.closest(".wish, .heart-btn");
    if (!h) return;
    e.preventDefault();
    h.classList.toggle("is-active");
    const on = h.classList.contains("is-active");
    if (h.dataset.handle) {
      try {
        let list = JSON.parse(localStorage.getItem("tcc-wish") || "[]").filter((x) => x !== h.dataset.handle);
        if (on) list.unshift(h.dataset.handle);
        localStorage.setItem("tcc-wish", JSON.stringify(list));
      } catch (err) {}
    }
    showToast(on ? "Saved to wishlist" : "Removed from wishlist");
  });

  try {
    const saved = JSON.parse(localStorage.getItem("tcc-wish") || "[]");
    $$("[data-handle].wish, [data-handle].heart-btn").forEach((h) => h.classList.toggle("is-active", saved.includes(h.dataset.handle)));
  } catch (e) {}

  /* ---------- remove with collapse ---------- */
  document.addEventListener("click", (e) => {
    const r = e.target.closest("[data-remove]");
    if (!r) return;
    e.preventDefault();
    const item = r.closest(r.dataset.remove);
    if (!item) return;
    item.classList.add("is-removing");
    setTimeout(() => {
      const parent = item.parentElement;
      item.remove();
      recalcCart();
      const empty = parent && parent.dataset.empty && $(parent.dataset.empty);
      if (empty && !parent.children.length) { empty.hidden = false; empty.classList.add("is-in"); }
      const counter = $("[data-count-of]");
      if (counter && parent) counter.textContent = `${parent.querySelectorAll(counter.dataset.countOf).length} of 4 added`;
    }, 480);
  });

  /* ---------- cart quantities ---------- */
  const money = (n) => "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const money0 = (n) => "$" + n.toLocaleString("en-US");
  function recalcCart() {
    const rows = $$(".cart-row");
    if (!rows.length && !$("[data-subtotal]")) return;
    let sub = 0;
    rows.forEach((row) => {
      const unit = parseFloat(row.dataset.unit);
      const q = parseInt($(".qty b", row).textContent, 10);
      $(".cart-row__price b", row).textContent = money0(unit * q);
      sub += unit * q;
    });
    const disc = Math.round(sub * 0.05 * 100) / 100;
    const set = (sel, v) => $$(sel).forEach((el) => { el.textContent = v; });
    set("[data-subtotal]", money(sub));
    set("[data-discount]", "-" + money(disc));
    set("[data-total]", money(sub - disc));
  }
  $$(".qty").forEach((q) => q.addEventListener("click", (e) => {
    const b = e.target.closest("button");
    if (!b) return;
    const out = $("b", q);
    const n = Math.max(1, parseInt(out.textContent, 10) + (b.dataset.step === "+" ? 1 : -1));
    out.textContent = n;
    out.classList.remove("is-tick"); void out.offsetWidth; out.classList.add("is-tick");
    recalcCart();
    const input = $("input", q);
    if (input) {
      input.value = n;
      clearTimeout(q._t);
      q._t = setTimeout(() => input.form && input.form.submit(), 700);
    }
  }));

  /* ---------- compare drawer ---------- */
  const openDrawer = () => { document.body.classList.add("drawer-open"); document.body.style.overflow = "hidden"; };
  const closeDrawer = () => { document.body.classList.remove("drawer-open"); document.body.style.overflow = ""; };
  $$("[data-open-drawer]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); }));
  $$("[data-close-drawer], .drawer-overlay").forEach((b) => b.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeDrawer(); document.body.classList.remove("menu-open"); document.body.style.overflow = ""; } });
  $$(".ditem button").forEach((b) => b.addEventListener("click", () => {
    if (b.dataset.state === "added") return;
    b.dataset.state = "added";
    b.innerHTML = '<img src="' + (window.TCC_ICONS || "assets/icons/") + 'check-black.svg" alt="">Added';
    showToast("Added to compare");
  }));

  /* ---------- product gallery ---------- */
  function swapGallery(btn) {
    const main = $(".gallery__main img");
    if (!main) return;
    main.style.opacity = "0";
    setTimeout(() => { main.src = $("img", btn).src; main.style.opacity = "1"; }, 250);
  }
  const gm = $(".gallery__main");
  if (gm) {
    gm.addEventListener("click", () => gm.classList.toggle("is-zoomed"));
    gm.addEventListener("mousemove", (e) => {
      const r = gm.getBoundingClientRect();
      $("img", gm).style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
    gm.addEventListener("mouseleave", () => gm.classList.remove("is-zoomed"));
  }

  /* ---------- toggles ---------- */
  $$(".toggle").forEach((t) => t.addEventListener("click", () => t.setAttribute("aria-checked", String(t.getAttribute("aria-checked") !== "true"))));

  /* ---------- order accordion ---------- */
  $$("[data-accordion]").forEach((row) => row.addEventListener("click", (e) => {
    const d = $(row.dataset.accordion);
    if (!d) return;
    e.preventDefault();
    d.classList.toggle("is-open");
  }));

  /* ---------- appointment date: no past days, no Sundays ---------- */
  $$("[data-appt-date]").forEach((d) => {
    const t = new Date();
    d.min = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
    d.addEventListener("input", () => {
      const day = d.value ? new Date(`${d.value}T12:00`).getDay() : -1;
      d.setCustomValidity(day === 0 ? "We're closed on Sundays — please pick Monday to Saturday." : "");
    });
  });

  /* ---------- forms: fake submit ---------- */
  $$("form[data-toast-submit]").forEach((f) => f.addEventListener("submit", (e) => {
    e.preventDefault();
    showToast(f.dataset.toastSubmit);
    const go = f.dataset.redirect;
    if (go) setTimeout(() => { document.body.classList.add("is-leaving"); setTimeout(() => { window.location.href = go; }, 520); }, 900);
  }));

  /* ---------- product: live spec summary ---------- */
  const specStone = $('[data-spec="stone"]');
  if (specStone) {
    const pick = (g) => ($(`[data-group="${g}"] > .is-active`)?.textContent || "").trim();
    const setSpec = (el, v) => { if (!el || el.textContent === v) return; el.textContent = v; el.classList.remove("is-flash"); void el.offsetWidth; el.classList.add("is-flash"); };
    document.addEventListener("click", (e) => {
      if (!e.target.closest('[data-group="shape"], [data-group="weight"], [data-group="metal"]')) return;
      setSpec(specStone, `${pick("weight")} ${pick("shape")}`);
      setSpec($('[data-spec="metal"]'), `18K ${pick("metal")}`);
    });
  }

  /* ---------- product: lightbox ---------- */
  $$("[data-lightbox]").forEach((gal) => {
    let items = [];
    const collect = () => $$("figure", gal).filter((f) => $("img", f));
    const lb = document.createElement("div");
    lb.className = "lightbox";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", "Image viewer");
    lb.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close">×</button><button class="lightbox__prev" type="button" aria-label="Previous image">←</button><img class="lightbox__img" alt=""><button class="lightbox__next" type="button" aria-label="Next image">→</button><p class="lightbox__cap"></p>';
    document.body.appendChild(lb);
    const img = $(".lightbox__img", lb);
    let idx = 0;
    let lastFocus = null;
    const show = (i, animate) => {
      idx = (i + items.length) % items.length;
      const it = items[idx];
      const apply = () => { img.src = it.src; img.alt = it.alt; $(".lightbox__cap", lb).textContent = `${it.cap ? `${it.cap} · ` : ""}${idx + 1} / ${items.length}`; img.classList.remove("is-swap"); };
      if (animate) { img.classList.add("is-swap"); setTimeout(apply, 200); } else apply();
    };
    const open = (i) => { items = collect().map((f) => ({ src: $("img", f).src, alt: $("img", f).alt, cap: $("figcaption", f)?.lastChild.textContent.trim() || "" })); lastFocus = document.activeElement; show(i, false); lb.classList.add("is-open"); document.body.style.overflow = "hidden"; $(".lightbox__close", lb).focus(); };
    const close = () => { lb.classList.remove("is-open"); document.body.style.overflow = ""; lastFocus?.focus(); };
    gal.addEventListener("click", (e) => {
      const fig = e.target.closest("figure");
      if (!fig || !e.target.closest("button")) return;
      const i = collect().indexOf(fig);
      if (i >= 0) open(i);
    });
    $(".lightbox__close", lb).addEventListener("click", close);
    $(".lightbox__prev", lb).addEventListener("click", () => show(idx - 1, true));
    $(".lightbox__next", lb).addEventListener("click", () => show(idx + 1, true));
    lb.addEventListener("click", (e) => { if (e.target === lb) close(); });
    document.addEventListener("keydown", (e) => {
      if (!lb.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") show(idx - 1, true);
      if (e.key === "ArrowRight") show(idx + 1, true);
    });
  });

  /* ---------- catalog: filters + sort ---------- */
  $$("[data-catalog]").forEach((ctl) => {
    const grid = $(ctl.dataset.catalog);
    if (!grid) return;
    const facets = $$("[data-facet]", ctl);
    const sort = $("[data-sort]", ctl);
    const countEl = $("[data-result-count]", ctl);
    const empty = $("#catalog-empty");
    const clears = $$("[data-clear]");
    const apply = () => {
      const f = Object.fromEntries(facets.map((s) => [s.dataset.facet, s.value]));
      const typeSel = facets.find((s) => s.dataset.facet === "type");
      const title = $("[data-catalog-title]");
      if (title) title.textContent = typeSel && typeSel.value ? typeSel.options[typeSel.selectedIndex].text : "All Pieces";
      const cards = [...grid.children];
      cards.forEach((c) => c.classList.add("is-filtering"));
      setTimeout(() => {
        let shown = 0;
        cards.forEach((c) => {
          const price = parseFloat(c.dataset.price);
          const [lo, hi] = (f.price || "0-Infinity").split("-").map(Number);
          const ok = (!f.type || c.dataset.type === f.type) && (!f.style || c.dataset.style === f.style) && (!f.stock || c.dataset.available === "true") && price >= lo && price < hi;
          c.classList.toggle("is-hidden", !ok);
          if (ok) shown++;
        });
        const by = sort ? sort.value : "featured";
        const cmp = { featured: (a, b) => a.dataset.order - b.dataset.order, "price-asc": (a, b) => a.dataset.price - b.dataset.price, "price-desc": (a, b) => b.dataset.price - a.dataset.price, name: (a, b) => a.dataset.name.localeCompare(b.dataset.name) }[by];
        cards.slice().sort(cmp).forEach((c) => grid.appendChild(c));
        if (countEl) countEl.textContent = `${shown} piece${shown === 1 ? "" : "s"}`;
        if (empty) empty.hidden = shown > 0;
        const active = facets.some((s) => s.value);
        clears.forEach((b) => { if (b.closest("[data-catalog]")) b.hidden = !active; });
        requestAnimationFrame(() => cards.forEach((c, i) => {
          c.style.transitionDelay = `${(i % 4) * 0.05}s`;
          c.classList.remove("is-filtering");
          setTimeout(() => { c.style.transitionDelay = ""; }, 700);
        }));
      }, 250);
    };
    facets.forEach((s) => s.addEventListener("change", () => { s.parentElement.classList.toggle("is-active", !!s.value); apply(); }));
    if (sort) sort.addEventListener("change", () => { $("[data-sort-label]", ctl).textContent = sort.options[sort.selectedIndex].text; apply(); });
    clears.forEach((b) => b.addEventListener("click", () => { facets.forEach((s) => { s.value = ""; s.parentElement.classList.remove("is-active"); }); apply(); }));
    // Category links arrive as catalog.html?type=necklaces — preselect that filter.
    const preset = new URLSearchParams(location.search).get("type");
    const typeSel = facets.find((sel) => sel.dataset.facet === "type");
    if (preset && typeSel && [...typeSel.options].some((o) => o.value === preset)) {
      typeSel.value = preset;
      typeSel.parentElement.classList.add("is-active");
      apply();
    }
  });

  /* ---------- search ---------- */
  const searchInput = $("[data-search]");
  if (searchInput) {
    const grid = $(searchInput.dataset.search);
    const countEl = $("[data-search-count]");
    const empty = $("#search-empty");
    const terms = $$("[data-search-term]");
    const run = () => {
      const words = searchInput.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      [...grid.children].forEach((c) => {
        const text = c.dataset.searchText || "";
        const ok = words.every((w) => text.includes(w) || (w.endsWith("s") && text.includes(w.slice(0, -1))));
        c.classList.toggle("is-hidden", !ok);
        if (ok) shown++;
      });
      const q = searchInput.value.trim();
      countEl.textContent = q ? `${shown} result${shown === 1 ? "" : "s"} for “${q}”` : `${shown} pieces`;
      empty.hidden = shown > 0;
      terms.forEach((t) => t.classList.toggle("is-active", t.dataset.searchTerm.toLowerCase() === q.toLowerCase()));
      try { const u = new URL(location.href); if (q) u.searchParams.set("q", q); else u.searchParams.delete("q"); history.replaceState(null, "", u); } catch (e) {}
    };
    searchInput.addEventListener("input", run);
    terms.forEach((t) => t.addEventListener("click", () => { searchInput.value = t.dataset.searchTerm; run(); searchInput.focus(); }));
    const initial = new URLSearchParams(location.search).get("q");
    if (initial) { searchInput.value = initial; run(); }
    grid.addEventListener("tcc:rendered", run);
  }
})();
